import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

// Function to initialize the chat widget
function initChatWidget() {
  // Look for existing root or create one
  let rootElement = document.getElementById('root') || document.getElementById('enterone-chat-widget-root');
  
  if (!rootElement) {
    rootElement = document.createElement('div');
    rootElement.id = 'enterone-chat-widget-root';
    document.body.appendChild(rootElement);
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Auto-initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initChatWidget);
} else {
  initChatWidget();
}

// Expose initialization function globally for manual control
window.EnterOneChatWidget = window.EnterOneChatWidget || {};
window.EnterOneChatWidget.render = initChatWidget;

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
